import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel", "filterBtn"]

  open(event) {
    event?.preventDefault()
    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("hidden")
  }

  close(event) {
    event?.preventDefault()
    this.backdropTarget.classList.add("hidden")
    this.panelTarget.classList.add("hidden")
  }

  filter(event) {
    const filter = event.currentTarget.dataset.filter
    this.filterBtnTargets.forEach(btn => btn.classList.toggle("pu-pos-pill-active", btn === event.currentTarget))
    this.panelTarget.querySelectorAll("[data-state]").forEach(el => {
      el.classList.toggle("hidden", filter !== "all" && el.dataset.state !== filter)
    })
  }

  connect() {
    this._esc = (e) => { if (e.key === "Escape") this.close() }
    window.addEventListener("keydown", this._esc)
  }

  disconnect() {
    window.removeEventListener("keydown", this._esc)
  }
}
